module.exports = __webpack_public_path__ + "static/media/8.bdb40b8c.jpg";